import {useTranslation} from 'react-i18next';
import * as css from './BrandingPage.css';
import PageWrapper from '../components/pageWrapper/PageWrapper';
import TickchakLoader from '../../component/tickchakLoader/TickchakLoader';
import BrandingMenu from './menu/menu';
import BtnLanguages from '../../component/button/btnLanguages/BtnLanguages';
import AIGeneratorButton from '../../component/aiMessageGenerator/aiGeneratorButton/AIGeneratorButton';
import {DELIVERY_TYPES} from './menu/brandingConfig';
import {BrandingContext} from './context/BrandingContext';
import {useBrandingPage} from './hooks/useBrandingPage';
import {useBrandingPageActions} from './hooks/useBrandingPageActions';

function BrandingPage() {
    const {t} = useTranslation('branding');
    const page = useBrandingPage();
    const actions = useBrandingPageActions({
        messageType: page.messageType,
        deliveryType: page.deliveryType,
        eventWhatsAppStatus: page.eventWhatsAppStatus,
        eventEid: page.eventEid,
        aiGeneratorShow: page.aiGeneratorShow,
    });

    if(page.isLoading) {
        return <TickchakLoader showClass="show" />;
    }

    return (
        <BrandingContext.Provider value={page.contextValue}>
            <PageWrapper
                image="ticketsGroups"
                routing={{subTitle: t(page.deliveryType), title: t('branding'), id: 'branding'}}
                SubMenuChildren={page.PreviewComponent || null}
                subMenuProps={page.CompPreviewProps}
                operations={actions.operations}
                leftTitle={t('preview')}
                mobileActions={actions.mobileActions}
            >
                <css.container data-cy="brandingPage">
                    {page.isTablet && (
                        <css.languageBtn>
                            <BtnLanguages />
                            {page.deliveryType === DELIVERY_TYPES.whatsapp && (
                                <AIGeneratorButton {...actions.aiGeneratorButtonProps} />
                            )}
                        </css.languageBtn>
                    )}
                    <css.designEmailArea>
                        <BrandingMenu />
                        <css.left className={page.isKeyboardOpen ? 'keyboardOpen' : ''}>
                            {page.Comp && <page.Comp />}
                        </css.left>
                    </css.designEmailArea>
                </css.container>
                {page.PreviewComponent && <page.PreviewComponent {...page.previewProps} />}
            </PageWrapper>
        </BrandingContext.Provider>
    );
}

export default BrandingPage;
